import { produce } from 'immer';
import { StoreApi, create } from 'zustand';
import {
  SignUpStepActions,
  SignUpStepState,
  SignUpStepStore,
  SignUpStep,
} from '~/types';

const initSignUpStepState = (): SignUpStepState => ({
  step: 'CheckEmail',
  type: 'email',
  progress: 0,
  subProgress: 0,
  agreement: {
    required: false,
    required2: false,
    marketing: false,
  },
  verifyEmail: {
    email: '',
  },
  createPassword: {
    password: '',
  },
  profile: {
    name: '',
    nickName: '',
    birth: '',
    gender: '',
  },
  language: {
    language: '',
  },
});

const signUpStepActions = (
  set: StoreApi<SignUpStepStore>['setState'],
): SignUpStepActions => ({
  setStep: (step: SignUpStep) => {
    set(
      produce((state: SignUpStepStore) => {
        state.step = step;
      }),
    );
  },
  setType: (type: 'email' | 'sns') => {
    set(
      produce((state: SignUpStepStore) => {
        state.type = type;
      }),
    );
  },
  setProgress: (progress: number) => {
    set(
      produce((state: SignUpStepStore) => {
        state.progress = progress;
      }),
    );
  },

  setSubProgress: (subProgress: number) => {
    set(
      produce((state: SignUpStepStore) => {
        state.subProgress = subProgress;
      }),
    );
  },

  setRequired: (required: boolean) => {
    set(
      produce((state: SignUpStepStore) => {
        state.agreement.required = required;
      }),
    );
  },
  setRequired2: (required2: boolean) => {
    set(
      produce((state: SignUpStepStore) => {
        state.agreement.required2 = required2;
      }),
    );
  },
  setMarketing: (marketing: boolean) => {
    set(
      produce((state: SignUpStepStore) => {
        state.agreement.marketing = marketing;
      }),
    );
  },

  setEmail: (email: string) => {
    set(
      produce((state: SignUpStepStore) => {
        state.verifyEmail.email = email;
      }),
    );
  },
  setPassword: (password: string) => {
    set(
      produce((state: SignUpStepStore) => {
        state.createPassword.password = password;
      }),
    );
  },
  setName: (name: string) => {
    set(
      produce((state: SignUpStepStore) => {
        state.profile.name = name;
      }),
    );
  },
  setNickName: (nickName: string) => {
    set(
      produce((state: SignUpStepStore) => {
        state.profile.nickName = nickName;
      }),
    );
  },
  setBirth: (birth: string) => {
    set(
      produce((state: SignUpStepStore) => {
        state.profile.birth = birth;
      }),
    );
  },
  setGender: (gender: string) => {
    set(
      produce((state: SignUpStepStore) => {
        state.profile.gender = gender;
      }),
    );
  },
  setLanguage: (language: string) => {
    set(
      produce((state: SignUpStepStore) => {
        state.language.language = language;
      }),
    );
  },

  resetAll: () => {
    set(
      produce((state: SignUpStepStore) => {
        state.agreement = {
          required: false,
          required2: false,
          marketing: false,
        };
        state.verifyEmail = {
          email: '',
        };
        state.createPassword = {
          password: '',
        };
        state.profile = {
          name: '',
          nickName: '',
          birth: '',
          gender: '',
        };
      }),
    );
  },
});

const useSignUpStepStore = create<SignUpStepStore>((set) => ({
  ...initSignUpStepState(),
  ...signUpStepActions(set),
}));
export default useSignUpStepStore;
